import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const purposeService = {
    getAllPurposes,
    updatePurposeStatus,
    getPurpose,
    updatePurpose,
    createPurpose,
};

const MODULE = {
    PURPOSE: 'rnd-purposes',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Purpose') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllPurposes(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            name: filter.name,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.PURPOSE}`, requestOptions)
}


export function updatePurposeStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.PURPOSE}/${data.id}`, requestOptions)
}

export async function getPurpose(id) {
    return await apiHelper(API_URL).get(`/${MODULE.PURPOSE}/${id}`)
}

export function updatePurpose(data) {
    const requestOptions = {
        name: data.name,
    }
    return apiHelper(API_URL).put(`/${MODULE.PURPOSE}/${data.id}`, requestOptions)
}

export function createPurpose(data) {
    const requestOptions = {
        name: data.name,
    }

    return apiHelper(API_URL).post(`/${MODULE.PURPOSE}`, requestOptions)
}